import React, { useState } from "react";
import CandidateDashboardNav from "../../candidate/CandidateDashboardNav";
// import { useNavigate } from "react-router";
import EmployerDashboardNav from "../../employer/EmployerDashboardNav";
import UpdatePassword from "../../candidate/UpdatePassword"; 
import ChangePhone from "../../candidate/ChangePhone"; 
import UpdateEmail from "../../candidate/UpdateEmail"; 
import Breadcrumb from "../../Breadcrumb";

const Setting = () => {
  const [activeSections, setActiveSections] = useState([]);// State for active section
  const usertype = localStorage.getItem("userType");
 
   const toggleSection = (section) => {
    setActiveSections((prevSections) => {
      // If section is already open, close it
      if (prevSections.includes(section)) {
        return prevSections.filter((s) => s !== section);
      }
      // Otherwise, open it
      return [...prevSections, section];
    });
  };

  //Helper to check if a section is open
  const isSectionOpen = (section) => activeSections.includes(section);


  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Settings</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Settings</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Settings"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Settings", active: true }
        ]}
      />
      <div className="user-profile py-120">
        <div className="container">
          <div className="row">
            {usertype==='employer'?<EmployerDashboardNav/> :<CandidateDashboardNav />}
            <div className="col-lg-9">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <h4 className="card-title text-primary mb-4">
                    Account Settings
                  </h4>
                  <ul className="list-group">
                  <li
                      className="list-group-item d-flex align-items-center justify-content-between border-0 mb-2 p-3 rounded shadow-sm bg-light cursor-pointer"
                      onClick={() => toggleSection("password")}
                    >
                      <div className="d-flex align-items-center">
                        <i className="fas fa-key text-primary me-3 fs-5"></i>
                        <span className="fs-6 fw-semibold">
                          Update Password
                        </span>
                      </div>
                      <i
                        className={`fas fa-chevron-${
                          isSectionOpen("password") ? "down" : "right"
                        } text-muted`}
                      ></i>
                    </li>
                    {isSectionOpen("password") && <UpdatePassword />} 

                    <li
                      className="list-group-item d-flex align-items-center justify-content-between border-0 mb-2 p-3 rounded shadow-sm bg-light cursor-pointer"
                      onClick={() => toggleSection("phone")}
                    >
                      <div className="d-flex align-items-center">
                        <i className="fas fa-phone text-primary me-3 fs-5"></i>
                        <span className="fs-6 fw-semibold">Change Phone</span>
                      </div>
                      <i
                        className={`fas fa-chevron-${
                          isSectionOpen("phone") ? "down" : "right"
                        } text-muted`}
                      ></i>
                    </li>
                    {isSectionOpen("phone") && <ChangePhone />}
                    <li
                      className="list-group-item d-flex align-items-center justify-content-between border-0 mb-2 p-3 rounded shadow-sm bg-light cursor-pointer"
                      onClick={() => toggleSection("email")}
                    >
                      <div className="d-flex align-items-center">
                        <i className="fas fa-envelope text-primary me-3 fs-5"></i>
                        <span className="fs-6 fw-semibold">Update Email</span>
                      </div>
                      <i
                        className={`fas fa-chevron-${
                          isSectionOpen("email") ? "down" : "right"
                        } text-muted`}
                      ></i>
                    </li>
                    {isSectionOpen("email") && <UpdateEmail />}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
